<template>
  <v-slide-y-transition mode="out-in">
    <div>
      <v-stepper :value="stepke" class="mt-0 pt-0">
        <v-stepper-header>
          <template v-for="(steper, i) in stepers" >
            <v-divider v-if="i>0" :key="i+'divider'"></v-divider>
            <v-stepper-step :key="i" 
              :class="stepke === steper.id ?'grey lighten-4':''" 
              :step="steper.no" @click="backToStep(steper.id, steper)" 
              :complete="stepke > steper.id" 
              >
              {{steper.name}}
              <v-progress-linear 
                :indeterminate="true" 
                v-if="steper.loading" 
                class="ma-0" 
                height="3">
              </v-progress-linear>
            </v-stepper-step>
          </template>
        </v-stepper-header>        
      </v-stepper>
      <template>
        <v-progress-linear class="ma-0 pa-0" :indeterminate="true" v-if="loadingData"></v-progress-linear>
      </template>
      <v-container class="pa-2 chat-drawer-container fluid grid-list-md">      
        <v-layout row wrap>
          <v-flex lg12 md12 sm12 xs12>
            <v-stepper :value="stepke" class="mt-0 pt-0">
              <v-stepper-items>
                <v-stepper-content step="1" class="pa-1">
                  <step1 :tingkat_id.sync="tingkat_id" :voucher_valid.sync="voucher_valid" :jalur_id.sync="jalur_id" :voucher.sync="voucher" v-on:next="keStep2()"></step1>                                  
                </v-stepper-content>
                <v-stepper-content step="2" class="pa-0">
                  <step2 :tingkat_id.sync="tingkat_id" :jalur_id.sync="jalur_id" :voucher.sync="voucher" :stepke.sync="stepke"></step2>                                  
                </v-stepper-content>
                <v-stepper-content step="3" class="pa-1">
                  <step3 :stepke.sync="stepke"></step3>                                  
                </v-stepper-content>
                <v-stepper-content step="4" class="pa-1">
                  <step4 :stepke.sync="stepke"></step4>                                   
                </v-stepper-content>
                <v-stepper-content step="5" class="pa-1">
                  <step5 :stepke.sync="stepke"></step5>                           
                </v-stepper-content>
                <v-stepper-content step="6" class="pa-1">
                  <step6 :stepke.sync="stepke" :fm.sync="fm"></step6>                   
                </v-stepper-content>
                <v-stepper-content step="7" class="pa-1">
                  <step7 :stepke.sync="stepke"  v-if="(fm.status) >= 7"></step7>                  
                  <div v-else>
                    <v-alert type="info" :value="true">
                      Maaf, Sekarang belum periode pengumuman. Info lebih lanjut hubungi admin.
                      <br/>
                      <v-btn @click="backToStep(stepers.length-1)">Kembali</v-btn>
                    </v-alert>
                  </div>                                 
                </v-stepper-content>
              </v-stepper-items>            
            </v-stepper>
          </v-flex>          
        </v-layout>        
      </v-container>
    </div>    
  </v-slide-y-transition>  
</template>
<script>
import User  from '@/util/models/User';
import Model from '@/models/dashboard';
import Timeline from './components/timeline';

const  model = new Model();

import Step1 from './pages/step1';
import Step2 from './pages/step2';
import Step3 from './pages/step3';
import Step4 from './pages/step4';
import Step5 from './pages/step5';
import Step6 from './pages/step6';
import Step7 from './pages/step7';

export default {
  components: {
    Timeline,
    Step1,Step2,Step3,Step4,Step5,Step6,Step7, 
  },
  data:()=>({
    stepers: [], stepke:1,
    stepers_template:{
      '1':{
        '1':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},
          //{id:6, no:6, name:'Observsasi'},
          {id:7, no:6, name:'Pengumuman'},
        ],
        '3':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},          
          {id:7, no:6, name:'Pengumuman'},
        ]
      },
      '2':{
        '1':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},
          {id:6, no:6, name:'Tes'},
          {id:7, no:7, name:'Pengumuman'},
        ],
        '2':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:6, no:6, name:'Tes'},
          {id:7, no:7, name:'Pengumuman'},          
        ],
        '3':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},
          {id:7, no:6, name:'Pengumuman'},
        ],
        '4':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          //{id:3, no:3, name:'Pembayaran'},
          {id:4, no:3, name:'Angket Ortu'},
          {id:5, no:4, name:'Upload Berkas'},
          //{id:7, no:5, name:'Pengumuman'},
        ],
      },
      '3':{
        '1':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},
          {id:6, no:6, name:'Tes'},
          {id:7, no:7, name:'Pengumuman'},
        ],
        '2':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:6, no:5, name:'Tes'},
          {id:7, no:6, name:'Pengumuman'},
        ],
        '3':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          {id:3, no:3, name:'Pembayaran'},
          {id:4, no:4, name:'Angket Ortu'},
          {id:5, no:5, name:'Upload Berkas'},
          {id:7, no:6, name:'Pengumuman'},
        ],
        '4':[
          {id:1, no:1, name:'Sign Up'},
          {id:2, no:2, name:'Administrasi'},
          //{id:3, no:3, name:'Pembayaran'},
          {id:4, no:3, name:'Angket Ortu'},
          {id:5, no:4, name:'Upload Berkas'},
          //{id:7, no:5, name:'Pengumuman'},
        ],        
      },
    },
    user : User.attributes(),    
    firstime : true,
    fm : {},
    loadingData : true,
    tingkat_id: null,
    jalur_id: null,
    voucher: null,
    voucher_valid: false,

  }),
  watch:{
    'tingkat_id'(nTingkat){
      if(nTingkat && this.jalur_id)
      this.stepers = this.stepers_template[nTingkat][this.jalur_id]  
    },
    'jalur_id'(nJalur){
      if(this.tingkat_id && nJalur)
      this.stepers = this.stepers_template[this.tingkat_id][nJalur]  
    },
  },
  mounted(){
    this.stepers = this.stepers_template['2']['1']
    this.init()
  },
  methods:{
    async backToStep(step, steper={}){
      switch(step){
        case 1 || '1':
          this.stepke = 1;
          break;        
        default:
          if(this.fm.tingkat_id == 1){
            if(step <= (this.fm.status+1)){
              this.stepke = step;        
            }
          } else if(step <= this.fm.status){
            this.stepke = step;      
          }
          this.fm = await model.viewAdministrasi({id:this.user.id})                              
          break;
      }                  
    },

    keStep2(){
      if(this.jalur_id == 4 && this.voucher && !this.voucher_valid){
        return;
      }
      this.stepke = 2
    },

    init(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        this.loadingData = false
        this.fm = data;
        this.tingkat_id = data.tingkat_id
        this.jalur_id   = data.jalur_id
        this.voucher    = data.voucher
        console.log(data.status)
        switch(data.status){
          case 2 || '2':
            this.stepke = 3
            break;
          case 5 || '5':
            if(data.tingkat_id > 1 && (data.jalur_id == 1 || data.jalur_id == 2)){
              this.stepke = 6              
            } else {
              this.stepke = 5
              //this.backToStep(4)        
            }            
            break;          
          default:
            this.backToStep(this.fm.status)        
            break;  
        }        
      });
    }
  }
  /*watch:{
    stepke(newVal,oldVal){
      if(!newVal){
        return;
      }
      if(!this.firstime){
        this.loading[newVal] = true;              
      }      
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;
          if(newVal > oldVal && newVal > this.status){
            this.backToStep(this.status+1);               
          }                                                  
        }                
        setTimeout(()=>{          
          this.loading[newVal] = false;  
          let tambahan = 0
          if(this.firstime && this.fm.tingkat_id > 1 && (this.fm.jalur_id == 1 || this.fm.jalur_id == 2)){
            tambahan = 1;
          }        
          this.firstime = false;
          this.stepkeLocal = newVal+tambahan; 
          console.log(this.stepkeLocal)
        }, 100);
      });      
      //console.log(newVal)
      this.fm = {};
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        this.fm = data;
      });
    },    
  },
  computed: {    
               
  },  
  created(){
    
  },
  mounted(){    
  
    document.title = this.user.name;
    this.init();    
  },
  methods : {
    init(){
      this.loadingData = true;      
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);                        
        this.tingkat_id = this.fm.tingkat_id
        this.jalur_id   = this.fm.jalur_id
        this.voucher    = this.fm.voucher
        this.loadingData = false; 
        if(this.fm.gender){
          this.getCurrentStatus() 
        }        
      });      
    },

    getCurrentStatus(){
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;          
          console.log(this.status)
          if(this.status == 1){
              this.stepke = 2
          } else if(this.status == 2) {
              this.stepke = 3
          } else {
              this.backToStep((this.status));
              setTimeout(()=>{
                let tambahan = 0;
                if(this.firstime && (this.stepke == 4 || (this.stepke == 5 && this.fm.tingkat_id > 1))){
                  tambahan = 1;                
                }
                this.stepkeLocal = this.stepke+tambahan;              
              }, 100);
          }
        }      
        this.loadingData = false;  
      });
    },

    initBiasa(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);                             
      });
    },

    backToStep(step){
      if(step <= this.status){    
        if(this.stepke == step){
          this.getDataStatus();
        } else {
          this.stepke = step;
        }                   
      }
    },

    getDataStatus(){
      if(!this.firstime){
        //this.loading[this.stepke] = true;              
      }      
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;
          if( this.stepke > this.status+1){
            this.backToStep(this.status+1);               
          }                                                  
        }                
        setTimeout(()=>{          
          //this.loading[this.stepke] = false;  
          let tambahan = 0
          if(this.firstime && (this.stepke == 4 || (this.stepke == 5 && this.fm.tingkat_id > 1))){
            tambahan = 1;
          }        
          this.firstime = false;
          this.stepkeLocal = this.stepke+tambahan; 
        }, 100);
      });            
      this.fm = {};
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        this.fm = data;
      });
    },

    backFromStep7(){
      if(this.fm){
        if(this.fm.tingkat_id > 1 && (this.fm.jalur_id == 1 || this.fm.jalur_id == 2)){
          this.stepke = 6
        } else {
          this.stepke = 5
        }
      }
    }
  }*/
};
</script>


